import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/checkInSaga";
import Heatmap from "../../../components/charts/heatMap/heatMap";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import GroupByTimeOfDayChart from "./groupByTimeOfDayChart";
import GroupByFilter from "./groupByFilter";
import ShowPercentageToggle from "./ShowPercentageToggle";

function reOrderDays(series) {
  const clonedSeries = series.slice(0);

  return clonedSeries.map((item) => {
    if (item.data[0].toolTipData.includes("Sunday")) {
      item.data.push(item.data.shift());
    }

    return item;
  });
}

export const HeatMapChart = ({ groupByTimeOfDaySeries, categories }) => {
  const dispatch = useDispatch();
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);
  const showCheckInPrevPeriod = useSelector((state) => state.checkIns.showCheckInPrevPeriod);
  const series = useSelector((state) => state.checkIns.series);
  const tableDataLoading = useSelector((state) => state.checkIns.tableDataLoading);
  const modalTableData = useSelector((state) => state.checkIns.modalTableData);
  const currentSelectedCategory = useSelector((state) => state.checkIns.currentSelectedCategory);
  const groupByTimeOfDay = useSelector((state) => state.checkIns.groupByTimeOfDay);
  const seriesProps =
    groupByTimeOfDaySeries !== undefined ? groupByTimeOfDaySeries : reOrderDays(series);

  const chartSettings = {
    categories: categories,
    heatMapRadius: 15,
    stroke: 0.5,
    series: seriesProps,
    tableDataLoading,
    modalTableData,
    isUserQa,
    groupByTimeOfDay: groupByTimeOfDay,
    modalProps: {
      selectedCategory: currentSelectedCategory,
      showPrevPeriod: showCheckInPrevPeriod,
      progressInPercent: false,
      mainMetricTitle: "Check-in",
      detailsTitle: "Successful Check-In Details",
      tableHeight: showCheckInPrevPeriod ? 300 : 320
    }
  };

  const handleDataClick = (tableDataUid) => {
    let data = {
      tableDataUid
    };
    dispatch(actionCreators.getTableData(data));
  };

  return <Heatmap {...chartSettings} handleDataClick={handleDataClick} />;
};

export const CheckInHeatmap = () => {
  const groupByTimeOfDay = useSelector((state) => state.checkIns.groupByTimeOfDay);
  const isHeatMapLoading = useSelector((state) => state.checkIns.isHeatMapLoading);

  return (
    <div style={{ paddingTop: "50px", minHeight: "500px" }}>
      <div className="heatmap-heading">
        <h2>Check-In Heatmap</h2>
        <div className="heatmap-filters">
          <div className="group-by-filter">
            {isHeatMapLoading ? <LoadingAnimation uiLoader /> : <GroupByFilter />}
          </div>
          <ShowPercentageToggle />
        </div>
      </div>
      {isHeatMapLoading ? (
        <LoadingAnimation />
      ) : groupByTimeOfDay ? (
        <GroupByTimeOfDayChart />
      ) : (
        <HeatMapChart />
      )}
    </div>
  );
};
